/**
 * Options for a mutation that must keep working with no network (POS-I61).
 *
 * TanStack Query's default `networkMode: 'online'` PAUSES a mutation while the browser reports
 * the connection as lost (the window `offline` event flips `onlineManager`). The till's Complete
 * Sale mutation decides for itself what to do offline (it queues the sale in IndexedDB and the
 * sync service replays it later), so it must run regardless of the browser's online flag; paused,
 * the button stayed greyed forever and nothing was queued.
 */
export const OFFLINE_CAPABLE_MUTATION = { networkMode: 'always' } as const;

/**
 * POS-I67: the same rule for a QUERY that reads from the offline cache (IndexedDB). With the default
 * `networkMode: 'online'` such a query is paused while the browser is offline and never runs its
 * queryFn, so the serial picker stayed empty although the serials were cached.
 */
export const OFFLINE_CAPABLE_QUERY = { networkMode: 'always' } as const;
